import 'jquery-mask-plugin/dist/jquery.mask.min';
import 'jquery-validation/dist/jquery.validate';
import validation from './validation';

export default (function () {
    const form = {
        init() {
            $('.js--phone-num').mask('+38 (099) 999-99-99');
            validation.init();
        },
    };
    $(document).ready(() => {
        form.init();
    });
}());
